import api from './api';

export const getList = (params) => {
    return api().get('/product-category', { params });
};
export const deleteProductCategory = (params) => {
    const ids = (params || []).map((x) => x.product_category_id);
    return api().post(`/product-category/delete`, { ids });
};
export const getDetail = (id) => {
    return api().get(`/product-category/${id}`);
};
export const create = (params) => {
    return api().post(`/product-category`, params);
};
export const update = (id, params) => {
    return api().put(`/product-category/${id}`, params);
};
export const getOptionsTreeview = (params) => {
    return api().get('/product-category/get-options-treeview', { params });
};
export const exportExcel = (params) => {
    const header = {
        responseType: 'blob',
    }
    return api().get('/product-category/export-excel', { params, ...header });
}
export const getOptionsFunction = (params = {}) => {
    return api().get('/product-category/functions/get-options', { params });
};
export const getListAttributes = (params) => {
    return api().get('/product-category/attributes', { params });
}
export const createAttribute = (params) => {
    return api().post(`/product-category/attributes`, params);
};
export const getOptionsAttribute = (productCategoryId) => {
    return api().get(`/product-category/${productCategoryId}/attributes/get-options`);
};
export const getOptionsModel = (params) => {
    return api().get(`/product-category/${params?.productCategoryId}/product-model/get-options`, { params });
}